import { Button, Popover, Tag } from "@bedrock/components";
import { PopoverProps } from "@bedrock/components/lib/Popover";
import { TagProps } from "@bedrock/components/lib/Tag";
import { useMemoizedFn } from "ahooks";
import classNames from "classnames";
import React from "react";
import { FC, Fragment, useMemo } from "react";

export const EllipsisTags: FC<{
  className?: string;
  max?: number;
  popoverContentClassName?: string;
  popoverProps?: PopoverProps;
  tagProps?: Omit<TagProps, "text">;
  value?: any[];
  renderTag?: (tag: any) => React.ReactNode;
  /** 自定义渲染 popover trigger 的函数，接收两个参数：总标签数和隐藏标签数 */
  renderTrigger?: (totalCount: number, hiddenCount: number) => React.ReactNode;
}> = ({ className, max = 3, popoverContentClassName, popoverProps, tagProps, value, renderTag, renderTrigger }) => {
  const displayedTags = useMemo(() => value?.slice(0, max), [max, value]);

  const renderTagInner = useMemoizedFn((tag) => {
    if (renderTag) {
      return <Fragment key={tag}>{renderTag(tag)}</Fragment>;
    }
    if (typeof tag === "string" || typeof tag === "number") {
      return <Tag key={tag} size="small" {...tagProps} text={tag.toString()} />;
    }
    if (typeof tag === "object" && (tag.name || tag.value)) {
      return <Tag key={tag.value || tag.name} size="small" {...tagProps} text={tag.name || tag.value} color={tag?.color || tagProps?.color} />;
    }
    return null;
  });

  if (!displayedTags?.length) {
    return "-";
  }

  return (
    <div className={classNames("flex items-center gap-[4px]", className)}>
      {displayedTags.map((tag) => renderTagInner(tag))}
      {(value?.length ?? 0) > max && (
        <Popover
          placement="right"
          {...popoverProps}
          content={
            <div className={classNames("flex flex-wrap gap-x-[4px] gap-y-[8px]", popoverContentClassName)}>
              {value?.slice(max)?.map((tag) => renderTagInner(tag))}
            </div>
          }
        >
          {renderTrigger ? (
            renderTrigger(value?.length ?? 0, (value?.length ?? 0) - displayedTags.length)
          ) : (
            <Button size="small" type="link">
              ...共{value?.length}个
            </Button>
          )}
        </Popover>
      )}
    </div>
  );
};
